import { Article } from '@wix/answers-api';
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import { ArrowRightSmall } from '@wix/wix-ui-icons-common';

import { CHATBOT_REFERRALS } from '../../../constants';
import { useArticlePageBi } from '../../../utils/article-page-bi';
import { useStore } from '../../../zustand/stores';

import css from './index.module.scss';

type RelatedQuestionProps = {
  relatedQuestions: string[];
  article: Article;
  sendMessage: (message: string, forceReferral?: string) => void;
};

const RelatedQuestions = ({
  relatedQuestions,
  article,
  sendMessage,
}: RelatedQuestionProps) => {
  const { t } = useTranslation();
  const { suggestedQuestionTrack } = useArticlePageBi(article);
  const { setChatbotReferral, setChatbotNodeId } = useStore((state) => state.copilotSlice);

  const handleQuestionClick = async (question: string, index: number) => {
    await suggestedQuestionTrack(question, index + 1);
    setChatbotNodeId(null);
    setChatbotReferral(CHATBOT_REFERRALS.SUGGESTED_QUESTION);
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
    sendMessage(question, CHATBOT_REFERRALS.SUGGESTED_QUESTION);
  };

  return (
    <Box direction="vertical" gap={1}>
      <Text size="small" weight="normal">
        {t('article-page.copilot.related-questions.title')}
      </Text>
      <Box direction="vertical">
        {relatedQuestions.slice(0, 3).map((relatedQuestion, index) => (
          <Box
            direction="horizontal"
            key={relatedQuestion}
            className={css.relatedQuestion}
          >
            <ArrowRightSmall />
            <Text
              size="tiny"
              onClick={() => handleQuestionClick(relatedQuestion, index)}
              weight="thin"
              skin="primary"
            >
              {relatedQuestion}
            </Text>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default RelatedQuestions;
